import Slider from '@mui/material/Slider';
import { datacenter_marks } from '../../helpers';
import useMediaQuery from 'hooks/useMediaQuery';

function valuetext(value) {
    return `${value}`;
}

function valueLabelFormat(value) {
    return `${value} IP`;
}

const DatacenterTab = ({ sliderValue, onChange }) => {

    const handleChange = (event, value, activeThumb) => {
        onChange(value);
    };
    const isMobile = useMediaQuery('max-width: 640px')
    const isTablet = useMediaQuery('max-width: 1024px')
    let marksToShow = datacenter_marks;
    if (isMobile) {
        const markedEvenMarks = datacenter_marks.filter((mark) => mark.label).filter((mark, index) => index % 2 === 0);
        marksToShow = datacenter_marks.map(mark => {
            if (markedEvenMarks.includes(mark) && mark !== markedEvenMarks[markedEvenMarks.length - 1]) {
                return { ...mark, label: null };
            }
            return mark;
        });
    }
    return (
        <div className="product-price-range">
            <Slider
                aria-label="Number of units"
                valueLabelFormat={valueLabelFormat}
                getAriaValueText={valuetext}
                step={null}
                valueLabelDisplay="on"
                marks={marksToShow}
                value={sliderValue}
                onChange={handleChange}
                min={1}
                max={1000}
            />
            {
                !isTablet &&
                <div className='product-price-range__labels body3'>
                    <div className='product-price-range__labels-item'>
                        Min: 1 IP
                    </div>
                    <div className='product-price-range__labels-item'>
                        Max: 1000 IP
                    </div>
                </div>
            }

        </div>
    );
};

export default DatacenterTab;
